import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  applyContractResolutionMutation,
  getContractHealthOptions,
  getContractHealthQueryKey,
  listContractEventsOptions,
} from '../generated/api/@tanstack/react-query.gen.js';
import { adaptMutation } from './adapt-mutation.js';

export function useContractHealth(workflowId?: number) {
  const query = useQuery({
    ...getContractHealthOptions({ query: { workflowId } }),
    refetchInterval: 30_000,
  });
  if (query.isError) console.error('useContractHealth: failed to load contract health', query.error);
  return query;
}

export function useContractEvents(runId?: number) {
  return useQuery({
    ...listContractEventsOptions({ query: { runId } }),
    enabled: !!runId,
  });
}

export function useApplyContractResolution(workflowId?: number) {
  const queryClient = useQueryClient();
  return useMutation({
    ...adaptMutation(
      applyContractResolutionMutation(),
      (vars: { sourceStepId: number; mappings: Array<{ source: string; target: string }> }) => {
        if (workflowId == null) throw new Error('useApplyContractResolution requires a workflowId');
        return { body: { workflowId, sourceStepId: vars.sourceStepId, mappings: vars.mappings } };
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getContractHealthQueryKey({ query: { workflowId } }) });
    },
  });
}
